import { TextField, Theme, } from "@mui/material";
import { createStyles, makeStyles } from '@mui/styles';
import { useEffect, useState } from "react";
import requestMissingContexts, {
  determineConfig,
  determineConfigLong,
} from "../../utils/GetContext";

interface RequestTinyProps {
  data: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    requestedBy: {
      width: "280px"
    },
    onDate: {
      width: "120px"
    },
    requestNum: {
      width: "120px"
    }
  })
);

export default function RequestTiny(props: RequestTinyProps) {
  const [codes, setCodes] = useState<any>();
  const classes = useStyles();
  let last = props.data && props.data.requests && props.data.requests[0];

  useEffect(() => {
    if (codes && codes.length > 0) return;
    requestMissingContexts(["vp_req_status"]).then((v: any) => {
      setCodes(v);
    });
  }, [codes]);

  if (!last) return <div />;

  return (
    <div>
      <TextField
        id="outlined-full-width"
        label="Request Status"
        style={{ marginRight: 8 }}
        placeholder="Placeholder"
margin="dense"
        value={determineConfig(codes, "vp_req_status", last.requestStatus)}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
      />
      <TextField
        id="outlined-full-width"
        label="Requested By"
        className={classes.requestedBy}
        style={{ marginRight: 8 }}
        value={last.requestedBy}
margin="dense"
        variant="outlined"
      />
      <TextField
        id="outlined-full-width"
        label="Requested On"
        style={{ marginRight: 8 }}
        className={classes.onDate}
        value={new Date(Date.parse(last.requestedDt)).toLocaleDateString()}
        placeholder="Placeholder"
margin="dense"
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
      />
      <TextField
        id="outlined-full-width"
        label="SAP Ticket #"
        style={{ marginRight: 8 }}
        className={classes.requestNum}
        value={last.sapRequestNumber}
        placeholder="Placeholder"
margin="dense"
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
      />
    </div>
  );
}
